import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Form, Row } from 'antd';
import moment from 'moment';

import { setShipmentEditStatus } from '../../../../redux/shipment/ShipmentActions';
import FormDatePicker from '../../../components/Inputs/FormDatePicker';
import FormInput from '../../../components/Inputs/FormInput';
import FormSelectBox from '../../../components/Inputs/FormSelectBox';
import SecondaryLabel from '../../../components/Labels/SecondaryLabel';
import Paper from '../../../components/Paper/Paper';
import SaveCancelButtons from '../../../screens/Shipment/components/SaveCancelButtons';
import { SHIPMENT_TYPE, WEIGHT_PER_UNIT } from './constants';

const SaverShipmentTransportForm = ({
  form,
  shipmentType,
  saversMenuType,
  partnerLocationOptions,
  index,
  label,
  trailerMovementData,
}) => {
  const shipmentEditStatus = useSelector((state) => state.shipment.shipmentEditStatus);
  const dispatch = useDispatch();
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    dispatch(setShipmentEditStatus(isEditMode));
  }, [isEditMode, dispatch]);

  const handleCancel = () => {
    setIsEditMode(false);
  };

  const mirrorFields = (fromPrefix, toPrefix, fields, form) => {
    const currentValues = form.getFieldsValue();
    const updates = {};

    fields.forEach((field) => {
      const fromField = `${fromPrefix}${field}`;
      const toField = `${toPrefix}${field}`;
      if (fromPrefix === 'origin') {
        updates[toField] = currentValues.trailerShippings[index][fromField];
        form.setFieldsValue({
          trailerReceivings: {
            [index]: {
              [toField]: currentValues.trailerShippings[index][fromField],
            },
          },
        });
      } else {
        updates[toField] = currentValues.trailerReceivings[index][fromField];
        form.setFieldsValue({
          trailerShippings: {
            [index]: {
              [toField]: currentValues.trailerReceivings[index][fromField],
            },
          },
        });
      }
    });
  };

  const handleSave = () => {
    setIsEditMode(false);
    const [from, to] = shipmentType === SHIPMENT_TYPE.org ? ['origin', 'destination'] : ['destination', 'origin'];
    const fields = ['bookOks', 'bookweight', 'furn', 'miscOks', 'miscweight', 'oli', 'softOks', 'softweight'];
    mirrorFields(from, to, fields, form);
  };

  const handleSetEditMode = () => {
    setIsEditMode(!isEditMode);
  };
  const handleFormChange = (event, name) => {
    const { id, value } = event.target;
    const val = value || '0';
    const parsedVal =
      trailerMovementData?.originCountry === 'AU'
        ? Math.round(Number.parseInt(val, 10) / WEIGHT_PER_UNIT) / 10.43
        : Math.round(Number.parseInt(val, 10) / WEIGHT_PER_UNIT);

    const currentValues = form.getFieldsValue();
    const updatedOrgLocations = currentValues[
      shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'
    ].map((entry) => {
      const updatedEntry = { ...entry };

      switch (id) {
        case 'txtSoftWeight':
          updatedEntry[`${shipmentType}softweight`] = val;
          updatedEntry[`${shipmentType}softOks`] = parsedVal;
          break;
        case 'txtMiscWeight':
          updatedEntry[`${shipmentType}miscweight`] = val;
          updatedEntry[`${shipmentType}miscOks`] = parsedVal;
          break;
        case 'txtBookWeight':
          updatedEntry[`${shipmentType}bookweight`] = val;
          updatedEntry[`${shipmentType}bookOks`] = parsedVal;
          break;
        default:
          updatedEntry[name] = val;
          break;
      }

      return updatedEntry;
    });

    form.setFieldsValue({
      [shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings']: updatedOrgLocations,
    });
  };
  return (
    <div className="h-100">
      <div className="h-100">
        <Paper border className="h-100">
          <Row
            className="border-bottom-muted align-items-center m-0 py-10 pr-20 w-full d-flex"
            style={{ position: 'relative' }}
          >
            <Col span={24} className="text-center">
              <span className="bold-text fw-600">{shipmentType === SHIPMENT_TYPE.org ? 'Origin' : 'Destination'}</span>
            </Col>
            {!(
              saversMenuType === 'Generate Inbound Transfer' ||
              saversMenuType === 'Generate Outbound Transfer' ||
              saversMenuType === 'Received at location' ||
              (saversMenuType === 'Edit' && !label.includes('Loaded'))
            ) && (
              <div style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)' }}>
                <SaveCancelButtons
                  isNew={false}
                  editMode={isEditMode}
                  onCancel={handleCancel}
                  lightMode={false}
                  shipmentEditStatus={shipmentEditStatus}
                  setEditMode={handleSetEditMode}
                  saveButtonType="button"
                  hideDeleteButton
                  onSave={handleSave}
                />
              </div>
            )}
          </Row>
          <Row gutter={30} className="p-10">
            <Col sm={8}>
              <Row>
                {isEditMode && (
                  <Col sm={24}>
                    <Form.Item name={[index, `${shipmentType}ShipLocation`]}>
                      <FormSelectBox
                        editMode
                        name={[index, `${shipmentType}ShipLocation`]}
                        margin="m-0"
                        placeholder="Select Shipping Location"
                        label={shipmentType === SHIPMENT_TYPE.org ? 'Shipping Location' : 'Receiving Location'}
                        options={partnerLocationOptions}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                )}
                {!isEditMode && (
                  <Col sm={24} className="mb-10">
                    <SecondaryLabel>
                      {shipmentType === SHIPMENT_TYPE.org ? 'Shipping Location : ' : 'Receiving Location : '}
                      {form.getFieldValue([
                        `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                        0,
                        `${shipmentType === SHIPMENT_TYPE.org ? 'originShipLocation' : 'destinationShipLocation'}`,
                      ])}
                    </SecondaryLabel>
                  </Col>
                )}
                {isEditMode && (
                  <Col sm={24}>
                    <Form.Item name={[index, `${shipmentType}softweight`]}>
                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                      <FormInput
                        margin="mb-0"
                        type="text"
                        name={[index, `${shipmentType}softweight`]}
                        id="txtSoftWeight"
                        placeholder="Soft Weight"
                        editMode
                        label="Soft Weight"
                        onChange={(e) => handleFormChange(e, `${shipmentType}softweight`, shipmentType)}
                        maxLength={5}
                      />
                    </Form.Item>
                  </Col>
                )}
                {!isEditMode && (
                  <Col sm={24} className="mb-15">
                    <SecondaryLabel>
                      Soft Weight :{' '}
                      {form.getFieldValue([
                        `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                        0,
                        `${shipmentType}softweight`,
                      ])}
                    </SecondaryLabel>
                  </Col>
                )}
                {isEditMode && (
                  <Col sm={24}>
                    <Form.Item name={[index, `${shipmentType}miscweight`]}>
                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                      <FormInput
                        margin="mb-0"
                        pattern="[0-9]*"
                        className="form-control form-control-sm"
                        type="text"
                        name={[index, `${shipmentType}miscweight`]}
                        editMode
                        placeholder="Misc Weight"
                        label="Misc Weight"
                        id="txtMiscWeight"
                        onChange={(e) => handleFormChange(e, `${shipmentType}miscweight`, shipmentType)}
                        maxLength={5}
                      />
                    </Form.Item>
                  </Col>
                )}
                {!isEditMode && (
                  <Col sm={24} className="mb-15">
                    <SecondaryLabel>
                      Misc Weight :{' '}
                      {form.getFieldValue([
                        `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                        0,
                        `${shipmentType}miscweight`,
                      ])}
                    </SecondaryLabel>
                  </Col>
                )}
                {isEditMode && (
                  <Col sm={24}>
                    <Form.Item name={[index, `${shipmentType}bookweight`]}>
                      {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
                      <FormInput
                        margin="mb-0"
                        pattern="[0-9]*"
                        editMode
                        type="text"
                        name={[index, `${shipmentType}bookweight`]}
                        id="txtBookWeight"
                        placeholder="Book Weight"
                        label="Book Weight"
                        onChange={(e) => handleFormChange(e, `${shipmentType}bookweight`, shipmentType)}
                        maxLength={5}
                      />
                    </Form.Item>
                  </Col>
                )}
                {!isEditMode && (
                  <Col sm={24} className="mb-15">
                    <SecondaryLabel>
                      Book Weight :{' '}
                      {form.getFieldValue([
                        `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                        0,
                        `${shipmentType}bookweight`,
                      ])}
                    </SecondaryLabel>
                  </Col>
                )}
              </Row>
            </Col>
            <Col sm={8}>
              <CalculateDetails isEditMode={isEditMode} shipmentType={shipmentType} form={form} index={index} />
            </Col>
            <Col sm={8}>
              <OtherDetails isEditMode={isEditMode} shipmentType={shipmentType} form={form} index={index} />
            </Col>
          </Row>
        </Paper>
      </div>
    </div>
  );
};
const OtherDetails = ({ isEditMode, shipmentType, form, index }) => {
  return (
    <>
      <Col sm={24}>
        <div style={{ height: '100%', visibility: 'hidden' }}>
          <div style={{ height: isEditMode ? '55px' : '34px' }} />
        </div>
      </Col>
      {isEditMode && (
        <Col sm={24}>
          <Form.Item
            name={[index, `${shipmentType === SHIPMENT_TYPE.org ? `${shipmentType}etd` : `${shipmentType}eta`}`]}
          >
            <FormDatePicker
              label={shipmentType === SHIPMENT_TYPE.org ? 'ETD' : 'ETA'}
              editMode
              name={[index, `${shipmentType === SHIPMENT_TYPE.org ? `${shipmentType}etd` : `${shipmentType}eta`}`]}
              margin="m-0"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            {shipmentType === SHIPMENT_TYPE.org ? 'ETD : ' : 'ETA : '}
            {moment(
              form.getFieldValue([
                `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                0,
                `${shipmentType === SHIPMENT_TYPE.org ? `${shipmentType}etd` : `${shipmentType}eta`}`,
              ]),
            ).format('YYYY-MM-DD')}
          </SecondaryLabel>
        </Col>
      )}
      {isEditMode && (
        <Col sm={24}>
          <Form.Item name={[index, `${shipmentType}furn`]}>
            {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
            <FormInput
              margin="mb-0"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              type="text"
              name={[index, `${shipmentType}furn`]}
              editMode
              placeholder="Furn"
              label="Furn"
              id="txtFurn"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            Furn :{' '}
            {form.getFieldValue([
              `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
              0,
              `${shipmentType}furn`,
            ])}
          </SecondaryLabel>
        </Col>
      )}
      {isEditMode && (
        <Col sm={24}>
          <Form.Item name={[index, `${shipmentType}oli`]}>
            {/** biome-ignore lint/correctness/useUniqueElementIds: TODO: Fix This */}
            <FormInput
              margin="mb-0"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              type="text"
              name={[index, `${shipmentType}oli`]}
              editMode
              placeholder="OLI"
              id="txtOLI"
              label="OLI"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            OLI :{' '}
            {form.getFieldValue([
              `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
              0,
              `${shipmentType}oli`,
            ])}
          </SecondaryLabel>
        </Col>
      )}
    </>
  );
};

const CalculateDetails = ({ isEditMode, shipmentType, form, index }) => {
  return (
    <>
      {isEditMode && (
        <Col sm={24}>
          <div style={{ height: '100%', visibility: shipmentType === SHIPMENT_TYPE.org ? 'visible' : 'hidden' }}>
            <Form.Item name={[index, `${shipmentType}SpotDate`]}>
              <FormDatePicker
                className="form-control form-control-sm"
                name={[index, `${shipmentType}SpotDate`]}
                margin="m-0"
                label="Spot Date"
                editMode={isEditMode}
              />
            </Form.Item>
          </div>
        </Col>
      )}
      {!isEditMode && (
        <Col
          sm={24}
          className="mb-15"
          style={{ visibility: shipmentType === SHIPMENT_TYPE.org ? 'visible' : 'hidden' }}
        >
          <SecondaryLabel>
            Spot Date :{' '}
            {moment(
              form.getFieldValue([
                `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
                0,
                `${shipmentType}SpotDate`,
              ]),
            ).format('YYYY-MM-DD')}
          </SecondaryLabel>
        </Col>
      )}
      {isEditMode && (
        <Col sm={24}>
          <Form.Item name={[index, `${shipmentType}softOks`]}>
            <FormInput
              margin="mb-0"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              type="text"
              name={[index, `${shipmentType}softOks`]}
              editMode={isEditMode}
              placeholder="Soft OKs"
              readOnly
              label="Soft OKs"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            Soft OKs :{' '}
            {form.getFieldValue([
              `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
              0,
              `${shipmentType}softOks`,
            ])}
          </SecondaryLabel>
        </Col>
      )}
      {isEditMode && (
        <Col sm={24}>
          <Form.Item name={[index, `${shipmentType}miscOks`]}>
            <FormInput
              margin="mb-0"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              type="text"
              name={[index, `${shipmentType}miscOks`]}
              editMode={isEditMode}
              placeholder="Misc Oks"
              readOnly
              label="Misc OKs"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            Misc OKs :{' '}
            {form.getFieldValue([
              `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
              0,
              `${shipmentType}miscOks`,
            ])}
          </SecondaryLabel>
        </Col>
      )}
      {isEditMode && (
        <Col sm={24}>
          <Form.Item name={[index, `${shipmentType}bookOks`]}>
            <FormInput
              margin="mb-0"
              pattern="[0-9]*"
              className="form-control form-control-sm"
              type="text"
              name={[index, `${shipmentType}bookOks`]}
              editMode={isEditMode}
              placeholder="Book OKs"
              readOnly
              label="Book OKs"
            />
          </Form.Item>
        </Col>
      )}
      {!isEditMode && (
        <Col sm={24} className="mb-15">
          <SecondaryLabel>
            Book OKs :{' '}
            {form.getFieldValue([
              `${shipmentType === SHIPMENT_TYPE.org ? 'trailerShippings' : 'trailerReceivings'}`,
              0,
              `${shipmentType}bookOks`,
            ])}
          </SecondaryLabel>
        </Col>
      )}
    </>
  );
};

export default SaverShipmentTransportForm;
